<section class="parked-events-section">
  <eventq-lined-tab label="Parked" [count]="totalCount()" />
  <eventq-data-table
    [columns]="columns"
    [rows]="parked.value()?.items ?? []"
    [sort]="sort()"
    [disabledRowIds]="disabledRowIds()"
    [loading]="parked.isLoading() && !parked.hasValue()"
    [skeletonCount]="5"
    [showLabelWhenEmpty]="true"
    emptyLabel="No parked events"
    (sortChange)="onSort($event)"
    (rowClick)="onRowClick($event)"
  />
</section>
